import { fixSmoothDndNodePrototypeBug } from './utils';

// 首先修正 smooth-dnd 组件的问题
fixSmoothDndNodePrototypeBug();

// 动态引入组件
const Container = () => import(/* webpackChunkName: "vueSmoothDnd" */ 'vue-smooth-dnd').then(res => res.Container);
const Draggable = () => import(/* webpackChunkName: "vueSmoothDnd" */ 'vue-smooth-dnd').then(res => res.Draggable);

export { Container, Draggable };
